
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"757","height":"551","viewBox":"0 0 757 551","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":"0.2","d":"M321.543 33.2901C88.5787 153.097 -139.531 521.79 107.162 422.92C230.559 373.465 252.075 563.847 383.662 549.424C488.213 537.963 512.595 522.97 617.162 510.922C780.267 492.13 774.205 348.484 729.366 238.607C667.269 86.4436 521.544 -69.5649 321.543 33.2901Z","fill":"url(#paint0_linear_3311_35022)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_3311_35022","x1":"572.924","y1":"431.522","x2":"179.575","y2":"-16.8482","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#006DB6"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FFB7A6","stop-opacity":"0.5"}})])])])
          )
        }
      }
    